import {
  GET_DATA,
  SEARCH_DATA,
  ADD_ITEM,
  EDIT_ITEM,
  OPEN_EDIT,
  OPEN_PREVIEW,
  RESET_DATA,
  LOG_ACTION,
  LOAD_MORE_DATA,
} from "../types";
import axios from "axios";
import { firebase } from "../../../firebase/initFirebase";
import moment from "moment";
import { store } from "../../store";
import { message } from "antd";
import S3 from "react-aws-s3";
import { doc, getDoc } from "firebase/firestore";

export const getProductInventory = (currentProduct) => {
  return (dispatch) => {
    var reduxState = store.getState();
    var userRole = reduxState.auth.user.role;
    var userLocation = reduxState.auth.user.branch;
    var useremail = reduxState.auth.user.email;
    var Firestore = firebase.firestore();
    var dataRef = Firestore.collection("inventory");
    // console.log(props)
    dataRef = dataRef.where("product", "==", currentProduct);
    if (userRole !== "admin" && userRole !== "manager") {
      dataRef = dataRef.where("location", "==", userLocation);
    }

    return dataRef.get();
  };
};

export const getProductInventoryofBranch = (locationID) => {
  return async (dispatch) => {
    var reduxState = store.getState();
    var userRole = reduxState.auth.user.role;

    var useremail = reduxState.auth.user.email;
    var Firestore = firebase.firestore();
    var dataRef = Firestore.collection("inventory");

    dataRef = dataRef.where("location", "==", locationID);

    return dataRef.get();
  };
};

export const getProductSpecificInventory = (currentProduct) => {
  return (dispatch) => {
    var reduxState = store.getState();
    var userRole = reduxState.auth.user.role;
    var userLocation = reduxState.auth.user.branch;
    var useremail = reduxState.auth.user.email;
    var Firestore = firebase.firestore();
    var dataRef = Firestore.collection("inventory");
    // console.log(props)
    dataRef = dataRef.where("product", "==", currentProduct);
    dataRef = dataRef.where("location", "==", userLocation);

    return dataRef.get();
  };
};

export const getProductSpecificInventoryWithLocation = (
  currentProduct,
  branch
) => {
  return async (dispatch) => {
    var reduxState = store.getState();
    var userRole = reduxState.auth.user.role;
    var userLocation = reduxState.auth.user.branch;
    var useremail = reduxState.auth.user.email;
    var Firestore = firebase.firestore();

    var inventoryID = `${branch.key}_${currentProduct.key}`;

    var inventoryLogRef = Firestore.collection("inventory").doc(inventoryID);

    try {
      const snapshot = await inventoryLogRef.get();
      if (snapshot.exists) {
        const jsonData = snapshot.data();
        return jsonData; // This will return the JSON data of the document.
      } else {
        console.log("Document does not exist");
        return null;
      }
    } catch (error) {
      console.error("Error fetching document:", error);
      return null;
    }
  };
};
export const addNewInventory = (newID) => {
  return (dispatch) => {
    var Firestore = firebase.firestore();
    var dataRef = Firestore.collection("inventory");
    var dataDoc = dataRef.doc(newID);
    return dataDoc;
  };
};

export const createLog = (data, docID) => {
  return (dispatch) => {
    var Firestore = firebase.firestore();
    var dataRef = Firestore.collection("inventory")
      .doc(docID)
      .collection("inventory_log");
    return dataRef.doc().set(data);
  };
};

export const setProductInventory = (
  productID,
  prod_name,
  newcount,
  mode,
  reason
) => {
  return async (dispatch) => {
    var Firestore = firebase.firestore();
    var reduxState = store.getState();
    var userLocation = reduxState.auth.user.branch;
    var userLocationName = reduxState.auth.user.branch_name;
    var userID = reduxState.auth.user.id;
    var userName = reduxState.auth.user.name;
    var inventoryID = `${userLocation}_${productID}`;
    var productRef = Firestore.collection("products").doc(productID);
    var inventoryRef = Firestore.collection("inventory").doc(inventoryID);
    var inventoryLogRef = Firestore.collection("inventory")
      .doc(inventoryID)
      .collection("inventory_log")
      .doc();

    var updateForm = {
      updated_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      updated_by: userID,
      updated_name: userName,
    };
    var newQuantity = 0;
    var restock = 0;
    var currentInventorySnap = await inventoryRef.get();
    var currentInventory = null;
    var inventoryform = {
      ...updateForm,
      reason: reason,
    };
    if (currentInventorySnap.exists) {
      currentInventory = currentInventorySnap.data();
      if (currentInventory.restock) {
        restock = currentInventory.restock;
      }
      if (mode == "change") {
        newQuantity = newcount;
      }
      if (mode == "add") {
        newQuantity =
          parseFloat(currentInventory.quantity) + parseFloat(newcount);
      }
      if (mode == "subtract") {
        newQuantity =
          parseFloat(currentInventory.quantity) - parseFloat(newcount);
        // if(newQuantity < 0){
        //   newQuantity = 0
        // }
      }
    } else {
      if (mode == "change") {
        newQuantity = parseFloat(newcount);
      }
      if (mode == "add") {
        newQuantity = parseFloat(newcount);
      }
      inventoryform = {
        ...updateForm,
        created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
        location: userLocation,
        location_name: userLocationName,
        product: productID,
        product_name: prod_name,
      };
    }
    inventoryform["restock"] = restock;
    inventoryform["quantity"] = newQuantity;

    var inventoryLogForm = {
      created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      reason: reason,
      created_by: userID,
      created_name: userName,
      quantity: newQuantity,
      restock: restock,
    };

    var prodForm = {
      ...updateForm,
    };
    prodForm[`${userLocation}_count`] = newQuantity;
    prodForm[`${userLocation}_restock`] = restock;

    console.log(prodForm);
    console.log(inventoryform);
    console.log(inventoryLogForm);

    var productEdit = await productRef.set(prodForm, { merge: true });

    var InventoryEdit = await inventoryRef.set(inventoryform, { merge: true });

    var makelog = await inventoryLogRef.set(inventoryLogForm);

    return newQuantity;
  };
};

export const setProductInventoryWithLocation = (
  productID,
  prod_name,
  newcount,
  mode,
  reason,
  currentLocation,
  currentLocationName
) => {
  return async (dispatch) => {
    var Firestore = firebase.firestore();
    var reduxState = store.getState();

    var userID = reduxState.auth.user.id;
    var userName = reduxState.auth.user.name;
    var inventoryID = `${currentLocation}_${productID}`;
    var productRef = Firestore.collection("products").doc(productID);
    var inventoryRef = Firestore.collection("inventory").doc(inventoryID);
    var inventoryLogRef = Firestore.collection("inventory")
      .doc(inventoryID)
      .collection("inventory_log")
      .doc();

    var updateForm = {
      updated_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      updated_by: userID,
      updated_name: userName,
    };
    var newQuantity = 0;
    var restock = 0;
    var currentInventorySnap = await inventoryRef.get();
    var currentInventory = null;
    var inventoryform = {
      ...updateForm,
      reason: reason,
    };
    if (currentInventorySnap.exists) {
      currentInventory = currentInventorySnap.data();
      if (currentInventory.restock) {
        restock = currentInventory.restock;
      }
      if (mode == "change") {
        newQuantity = newcount;
      }
      if (mode == "add") {
        newQuantity =
          parseFloat(currentInventory.quantity) + parseFloat(newcount);
      }
      if (mode == "subtract") {
        newQuantity =
          parseFloat(currentInventory.quantity) - parseFloat(newcount);
        // if(newQuantity < 0){
        //   newQuantity = 0
        // }
      }
    } else {
      if (mode == "change") {
        newQuantity = parseFloat(newcount);
      }
      if (mode == "add") {
        newQuantity = parseFloat(newcount);
      }
      inventoryform = {
        ...updateForm,
        created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
        location: currentLocation,
        location_name: currentLocationName,
        product: productID,
        product_name: prod_name,
      };
    }
    inventoryform["restock"] = restock;
    inventoryform["quantity"] = newQuantity;

    var inventoryLogForm = {
      created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      reason: reason,
      created_by: userID,
      created_name: userName,
      quantity: newQuantity,
      restock: restock,
    };

    var prodForm = {
      ...updateForm,
    };
    prodForm[`${currentLocation}_count`] = newQuantity;
    prodForm[`${currentLocation}_restock`] = restock;

    console.log(prodForm);
    console.log(inventoryform);
    console.log(inventoryLogForm);

    var productEdit = await productRef.set(prodForm, { merge: true });

    var InventoryEdit = await inventoryRef.set(inventoryform, { merge: true });

    var makelog = await inventoryLogRef.set(inventoryLogForm);

    return newQuantity;
  };
};

export const getProductInventoryLog = (branchID, productID) => {
  return async (dispatch) => {
    var reduxState = store.getState();
    var userRole = reduxState.auth.user.role;
    var Firestore = firebase.firestore();

    var inventoryID = `${branchID}_${productID}`;
    var inventoryLogRef = Firestore.collection("inventory")
      .doc(inventoryID)
      .collection("inventory_log");
    // console.log(props)
    inventoryLogRef = inventoryLogRef.orderBy("created_at", "desc");

    // inventoryLogRef = inventoryLogRef.limit(50);

    var documentSnapshots = await inventoryLogRef.get();

    var docs = documentSnapshots.docs;
    var lastVisible = documentSnapshots.docs[documentSnapshots.docs.length - 1];
    var dataArray = [];

    await Promise.all(
      docs.map(async (logItem) => {
        var newLog = {
          key: logItem.id,
          id: logItem.id,
          ...logItem.data(),
        };
        dataArray.push(newLog);
      })
    );
    return dataArray;
  };
};

export const getProductInventoryLogwithDateRange = (
  inventoryID,
  start_date,
  end_date
) => {
  return async (dispatch) => {
    var reduxState = store.getState();
    var userRole = reduxState.auth.user.role;
    var Firestore = firebase.firestore();

    var inventoryLogRef = Firestore.collection("inventory")
      .doc(inventoryID)
      .collection("inventory_log");
    // console.log(props)
    inventoryLogRef = inventoryLogRef.orderBy("created_at", "desc");
    inventoryLogRef = inventoryLogRef.where(
      "created_at",
      ">=",
      moment(start_date).startOf("day").format("YYYY-MM-DD HH:mm:ss")
    );
    inventoryLogRef = inventoryLogRef.where(
      "created_at",
      "<=",
      moment(end_date).endOf("day").format("YYYY-MM-DD HH:mm:ss")
    );

    var documentSnapshots = await inventoryLogRef.get();

    var docs = documentSnapshots.docs;
    var lastVisible = documentSnapshots.docs[documentSnapshots.docs.length - 1];
    var dataArray = [];

    await Promise.all(
      docs.map(async (logItem) => {
        var newLog = {
          key: logItem.id,
          id: logItem.id,
          ...logItem.data(),
        };
        dataArray.push(newLog);
      })
    );
    return dataArray;
  };
};

export const getProductInventoryLogLastestFromDate = (
  inventoryID,
  datePickerValue
) => {
  return async (dispatch) => {
    var reduxState = store.getState();
    var userRole = reduxState.auth.user.role;
    var Firestore = firebase.firestore();

    var inventoryLogRef = Firestore.collection("inventory")
      .doc(inventoryID)
      .collection("inventory_log");
    // console.log(props)
    inventoryLogRef = inventoryLogRef.orderBy("created_at", "desc");
    console.log(datePickerValue);
    console.log(datePickerValue[1]);
    let end_date = datePickerValue[1];
    // inventoryLogRef = inventoryLogRef.where('created_at', '>=',  moment(start_date).startOf('day').format('YYYY-MM-DD HH:mm:ss'))
    inventoryLogRef = inventoryLogRef.where(
      "created_at",
      "<=",
      moment(end_date).endOf("day").format("YYYY-MM-DD HH:mm:ss")
    );

    inventoryLogRef = inventoryLogRef.limit(1);

    var documentSnapshots = await inventoryLogRef.get();

    var docs = documentSnapshots.docs;
    var lastVisible = documentSnapshots.docs[documentSnapshots.docs.length - 1];
    var dataArray = [];

    await Promise.all(
      docs.map(async (logItem) => {
        var newLog = {
          key: logItem.id,
          id: logItem.id,
          ...logItem.data(),
        };
        dataArray.push(newLog);
      })
    );
    return dataArray;
  };
};

export const updateOrSaveInventoryWithAuditField = (
  currentProduct,
  branch,
  excludeValue
) => {
  return async (dispatch) => {
    var reduxState = store.getState();
    var userRole = reduxState.auth.user.role;
    var userLocation = reduxState.auth.user.branch;
    var useremail = reduxState.auth.user.email;
    var Firestore = firebase.firestore();

    var inventoryID = `${branch.key}_${currentProduct.key}`;
    var inventoryLogRef = Firestore.collection("inventory").doc(inventoryID);

    try {
      await inventoryLogRef.set(
        {
          excludeFromAudit: excludeValue, // This is the new field you'd like to add or update
        },
        { merge: true }
      ); // This ensures that the new data is merged with any existing data in the document

      console.log(
        "Document successfully updated/created with excludeFromAudit field."
      );
      return true; // Successfully updated/created
    } catch (error) {
      console.error("Error updating/creating document:", error);
      return false; // Failed to update/create
    }
  };
};
